/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:25 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/

/**
 * This class contains the common methods for parsing the income results
 */
export class ParserValues
{
    /**
	 * Public constructor
	 */
	constructor() { }
	
	/**
	 * @param stringValue with the string value
	 * @return a boolean
	 */
	static booleanParser(stringValue)
	{
		return (stringValue === true) ;
	}
	
	/**
	 * @param stringValue with the string value
	 * @return a number
	 */
	static numberParser(stringValue)
	{
		return parseInt(stringValue) ;
	}
	
	/**
	 * @param stringValue with the string value
	 * @return a float
	 */
	static floatParser(stringValue)
	{
		return parseFloat(stringValue) ;
	}
	
	/**
	 * @param stringValue with the string value
	 * @return a string
	 */
	static stringParser(stringValue)
	{
		return String(stringValue) ;
	}
	
	/**
	 * @param fileValue with the file value
	 * @return a float
	 */
	static fileParser(fileValue)
	{
		return fileValue ;
	}
};
